import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {concatMap} from 'rxjs/operators';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Crud} from '../../../shared/services/crud';
import {Router} from '@angular/router';

@Component({
  selector: 'app-ellipsis-user-grid',
  templateUrl: './ellipsis-user-grid.component.html',
  styleUrls: ['./ellipsis-user-grid.component.scss']
})
export class EllipsisUserGridComponent implements OnInit {

  private confirmDialog: BsModalRef;
  private dialogEntityid = '';

  @Input() editurl: string;
  @Input() adminentityurl: string;
  @Input() entityid: string;
  @Input() httpcrud: Crud;

  constructor(private modalservice: BsModalService,
              private router: Router) {
  } // constructor

  ngOnInit(): void {
  } // ngOnInit

  goToEditurl() {
    this.router.navigate([this.editurl]);
  } // goToEditurl

  goToEdittoolsurl() {
    this.router.navigate([this.editurl + '/tools']);
  } // goToEdittoolsurl

  confirmRemoveDialog(confirmtemplate: TemplateRef<any>) {
    this.dialogEntityid = this.entityid;
    this.confirmDialog = this.modalservice.show(confirmtemplate);
  } // confirmRemoveDialog

  // Method called by the template
  closeConfirmRemoveDialog() {
    this.dialogEntityid = '';
    this.confirmDialog.hide();
  } // closeConfirmRemoveDialog

  confirmEntityDeletion() {
    const query = this.httpcrud.removeEntity(this.dialogEntityid).pipe(
      concatMap(() => this.httpcrud.getEntities())
    );
    query.subscribe((allresults) => {
      this.closeConfirmRemoveDialog();
    });
  } // confirmEntityDeletion

}
